var _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _ellipse2, _ellipse3, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 128 128",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.355 122.044V76.706l-7.354-3.445-1.996-10.601h-26.01l-1.996 10.601-7.117 3.334v45.449z",
    fill: "#e2b48a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m116.96 127-1.9-24.286a22.457 22.457 0 0 0-12.86-18.586l-20.41-9.562v5.906h-2.326v3.1H45.225v-8.543L25.8 84.128a22.457 22.457 0 0 0-12.863 18.586L11.04 127z",
    fill: "#bac2d3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.037 83.64h-9.776l-1.862 4.341 5.611 7.141-3.262 15.658 6.247 13.535 6.999-14.558-2.932-14.927 4.443-7.305z",
    fill: "#da2a47"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.061 102.714A22.457 22.457 0 0 0 102.2 84.128l-18.6-8.716c-1.517 8.638-5.119 16.554-9.033 24.35a208.479 208.479 0 0 0-5.117 10.927c-.893 2.055-5.45 14.062-5.45 14.062s-7.388-18.39-8.733-21.876c-1.823-4.728-3.226-9.648-5.642-14.121a58.022 58.022 0 0 0-1.3-2.27c-4.11-1.614-6.223-5.1-6.145-10.031L25.8 84.128a22.457 22.457 0 0 0-12.863 18.586L11.04 127h105.92z",
    fill: "#707583"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M115.061 102.714A22.457 22.457 0 0 0 102.2 84.128l-18.6-8.716c-1.517 8.638-5.119 16.554-9.033 24.35a208.479 208.479 0 0 0-5.117 10.927c-.893 2.055-5.45 14.062-5.45 14.062s-7.388-18.39-8.733-21.876c-1.823-4.728-3.226-9.648-5.642-14.121a58.022 58.022 0 0 0-1.3-2.27c-4.11-1.614-6.223-5.1-6.145-10.031L25.8 84.128a22.457 22.457 0 0 0-12.863 18.586L11.04 127h105.92z",
    fill: "#384868"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M116.96 127h-14.34l-1.9-24.29a22.469 22.469 0 0 0-12.87-18.58l-5.67-2.66a57.993 57.993 0 0 0 1.41-6.06l18.61 8.72a22.459 22.459 0 0 1 12.86 18.58z",
    fill: "#2f3a5a"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.731,
    cy: 47.917,
    fill: "#e2b48a",
    rx: 8.43,
    ry: 4.717,
    transform: "rotate(-76.83 87.703 47.9)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.074,
    cy: 47.917,
    fill: "#e2b48a",
    rx: 4.717,
    ry: 8.43,
    transform: "rotate(-13.18 40.06 47.898)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.903,
    cy: 38.898,
    fill: "#f0c191",
    rx: 23.829,
    ry: 32.843
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M86.237 50.228s8.415-15.035 6.592-26.959S82.973 7.581 78.2 7.581c0 0-6.442-9.539-22.361-5.648s-22.32 21.372-19.308 32.4 5.02 16.094 5.02 16.094-2.008-14.1.251-21.885 9.037-13.932 11.673-11.8 19.454 1.425 22.215-3.3a17.018 17.018 0 0 1 6.753 11.086c.9 7.154 4.919 11.547 4.543 16.692s-.749 9.008-.749 9.008z",
    fill: "#2f3a5a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.315 69.583 64 83.571l12.778 8.781 5.98-17.351zM45.242 75.001l6.478 16.946L64 83.571 49.685 69.583z",
    fill: "#d9e2e9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m86.484 76.766-8.169-7.183-.017-.017s-.149 21.46-14.3 54.749c-14.154-33.289-14.3-54.749-14.3-54.749l-.017.017-8.168 7.183-1.439 12.143 6.773-1.083-5.079 7.7C44.713 102.7 64 125.1 64 125.1c3.035-3.351 19.742-22.693 22.343-29.033l-5.195-8.241 7.581.216z",
    fill: "#43567c"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMan);
export default __webpack_public_path__ + "static/media/man.4e0b8864c738966f2c21d5ddf57f7914.svg";
export { ForwardRef as ReactComponent };